import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type SnapshotOverrideViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  relatedEntityTypeValue?: { displayId: string; id: string } | null;
  relatedEntityType: string;
  relatedEntityIdValue?: { displayId: string; id: string } | null;
  relatedEntityId: string;
  pathValue?: { displayId: string; id: string } | null;
  path: string;
  valueValue?: { displayId: string; id: string } | null;
  value: string;
  noteValue?: { displayId: string; id: string } | null;
  note: string;
  activeValue?: { displayId: string; id: string } | null;
  active: boolean;
};

export const SnapshotOverrideViewForm: React.FC<SnapshotOverrideViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      relatedEntityType = "",
      relatedEntityId = "",
      path = "",
      value = "{}",
      note = "",
      active = false,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupSnapshotOverrideLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={relatedEntityType}
                  label={langStore.SnapshotOverrideRelatedEntityTypeLabel}
                />
                <ShowMultiLine
                  value={relatedEntityId}
                  label={langStore.SnapshotOverrideRelatedEntityIdLabel}
                />
                <ShowMultiLine
                  value={path}
                  label={langStore.SnapshotOverridePathLabel}
                />
                <ShowMultiLine
                  value={value}
                  label={langStore.SnapshotOverrideValueLabel}
                />
                <ShowMultiLine
                  value={note}
                  label={langStore.SnapshotOverrideNoteLabel}
                />
                <ShowBoolean
                  value={active}
                  label={langStore.SnapshotOverrideActiveLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
